/**
 * Recommendation Feedback API Service
 *
 * Handles thumbs up/down votes on individual neighborhood recommendations.
 * Backend reference: server/app/routes/recommendationFeedbackRoute.js
 *
 * Toggle UX:
 *   - Click 👍 first time:  submitRecommendationFeedback({ vote: 'up' })
 *   - Click 👎 (was 👍):    submitRecommendationFeedback({ vote: 'down' })
 *   - Click same button:    clearRecommendationFeedback()
 *
 * Created 2026-04-25 as part of Saturday's Block 3.
 */

import axios from 'axios';

const API_BASE = 'http://localhost:5050/api/recommendation-feedback';

/**
 * Upsert a thumbs-up or thumbs-down vote.
 *
 * @param {object} payload — required: { sessionId, neighborhoodName, city, state, vote }
 *                           optional: { recommendationRank, matchScore, matchedPersona,
 *                                       userPriorities, housingIntent }
 */
export const submitRecommendationFeedback = async (payload) => {
  try {
    const res = await axios.post(API_BASE, payload, {
      headers: { 'Content-Type': 'application/json' }
    });
    return { success: true, data: res.data };
  } catch (err) {
    const apiError = err?.response?.data;
    return {
      success: false,
      error: apiError?.details || apiError?.error || err?.message || 'Failed to save feedback.',
      status: err?.response?.status
    };
  }
};

/**
 * Clear an existing vote (toggle-off).
 *
 * @param {object} payload — { sessionId, neighborhoodName }
 */
export const clearRecommendationFeedback = async (payload) => {
  try {
    const res = await axios.delete(API_BASE, {
      headers: { 'Content-Type': 'application/json' },
      data: payload
    });
    return { success: true, data: res.data };
  } catch (err) {
    const apiError = err?.response?.data;
    return {
      success: false,
      error: apiError?.details || apiError?.error || err?.message || 'Failed to clear feedback.',
      status: err?.response?.status
    };
  }
};
